module.exports = __webpack_public_path__ + "img/vaughan.b40ee6ee.jpg";